import { useCallback, useState } from "react";
import * as React from "react";
import { PWSSessionBackend, ZypeSubscription, COAST_MESSAGES } from "@inferno/renderer-shared-core";
import { Button, ButtonKind, Heading } from "../../../../../../core/ui";
import { axiosErrorReason } from "../../../../lib/coastCommon";
import { CoastAlert, CoastAlertSuccess } from "../../common/coast-alert/CoastAlert.model";
import { CoastAlertDisplayError } from "../../common/coast-alert/CoastAlertDisplay.component";
import { UsersButton } from "../../common/UsersButton.components";

interface CoastUserCancelSubscriptionProps {
  updateSubscription: (s: ZypeSubscription, idx: number) => void;
  goToMainView: (v?: CoastAlert[]) => void;
  goBack: (v?: CoastAlert[]) => void;
  subscription: ZypeSubscription;
  session: PWSSessionBackend;
  idx: number;
}

export function CoastUserCancelSubscription({
  updateSubscription,
  goToMainView,
  subscription,
  session,
  goBack,
  idx,
}: CoastUserCancelSubscriptionProps) {
  const [cancelError, setCancelError] = useState<string>();
  const [isCanceling, setIsCanceling] = useState(false);

  const handleCancel = useCallback(
    async (event: React.SyntheticEvent) => {
      event.preventDefault();

      if (cancelError) {
        setCancelError("");
      }

      if (!session.state.accessToken) {
        return setCancelError(COAST_MESSAGES.MISSING_ACCESS_TOKEN);
      }

      setIsCanceling(true);

      try {
        const resp = await session.memberService.cancelSubscription(session.state.accessToken, subscription._id);
        updateSubscription({ ...subscription, ...resp.subscription }, idx);
        goToMainView([new CoastAlertSuccess(COAST_MESSAGES.SUBSCRIPTION_CANCEL_SUCCESS)]);
      } catch (e) {
        setCancelError(axiosErrorReason(e) || COAST_MESSAGES.UNEXPECTED_ERROR);
      } finally {
        setIsCanceling(false);
      }
    },
    [
      cancelError,
      goToMainView,
      idx,
      session.memberService,
      session.state.accessToken,
      subscription,
      updateSubscription,
    ],
  );

  return (
    <div className="component-coast-account-change-login">
      <Button className="button-back-to-account" kind={ButtonKind.CUSTOMIZED} click={() => goBack()}>
        Back
      </Button>

      <section className="account-sub-section">
        <CoastAlertDisplayError message={cancelError} isDisplayed={!!cancelError} />

        <Heading level={2}>Cancel Subscription</Heading>

        <p>
          Click the button below to cancel your subscription to Coast Insider. There are no partial refunds offered at
          this time.
        </p>

        <UsersButton
          click={e => !isCanceling && handleCancel(e)}
          isProcessing={isCanceling}
          label="Cancel Subscription"
        >
          Cancel Subscription
        </UsersButton>
      </section>
    </div>
  );
}
